import AuthBootstrap, { getAudience } from "auth-provider-wrapper";
import AlertProvider from "components/lynx-components/alert/AlertProvider";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import CacheBuster from "react-cache-buster";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createRoot } from "react-dom/client";
import ReactGA from "react-ga4";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import object from "../package.json";
import AppRoute from "./app-route";
import { DynamicThemeProvider } from "./components/DynamicThemeProvider";
import Layout from "./components/layout";
import { appStore } from "./modules/store";
import "./styles/components/Dashboard.css";
import "./styles/print.css";
import "./fonts.css";
import "./index.css";

import CssBaseline from "@mui/material/CssBaseline";
import { LicenseInfo } from "@mui/x-license";

import "mapbox-gl/dist/mapbox-gl.css";
import { Auth0Provider } from "@auth0/auth0-react";
import * as serviceWorker from "./serviceWorker";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
ReactGA.initialize("G-BZ2L5XJWK0");

export const store = appStore;
LicenseInfo.setLicenseKey(
  "ca93487e7caf1ce55c85236e4576b9eeTz0xMTE4NTYsRT0xNzc2OTg4Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);
TimeAgo.addDefaultLocale(en);
const container = document.getElementById("root");
const root = createRoot(container);

const providerConfig = {
  domain:
    window.location.hostname == "beta.lynx-esg.com" ||
    window.location.hostname == "demo.lynx-esg.com"
      ? "lynx-demo.us.auth0.com"
      : window.location.hostname == "lynx-esg.com" ||
          window.location.hostname == "staging.lynx-esg.com"
        ? "lynx-esg.us.auth0.com"
        : "dev-o5u1llqws5764afh.us.auth0.com",
  clientId:
    window.location.hostname == "beta.lynx-esg.com"
      ? "mzMqjT185tAkIy3nMu4PdSXThnNH7bLn"
      : window.location.hostname == "demo.lynx-esg.com"
        ? "wrMqwJWG8DUshqy74bByt55mVwYyvyvD"
        : window.location.hostname == "lynx-esg.com" ||
            window.location.hostname == "staging.lynx-esg.com"
          ? "YHhG3Nrt7f0qcfWd5CU11IAUZt0l2fBv"
          : "xZTJVCu3MO60OsGXHolX3uuwnt3YG0gt",
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: getAudience(),
    scope:
      "openid read:current_user update:current_user_metadata offline_access",
  },
  cacheLocation: "localstorage",
  useRefreshTokens: true,
};
const AppRedux = (props) => {
  const isProduction = process.env.NODE_ENV === "production";
  return (
    <CacheBuster
      currentVersion={object.version}
      isEnabled={isProduction}
      isVerboseMode={false}
      metaFileDirectory={"."}
    >
      <Auth0Provider {...providerConfig}>
        <AuthBootstrap />
        <Provider store={store}>
          <DynamicThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CssBaseline />
              <AlertProvider>
                <Router>
                  <Layout>
                    <DndProvider backend={HTML5Backend}>
                      <AppRoute />
                    </DndProvider>
                  </Layout>
                </Router>
              </AlertProvider>
            </LocalizationProvider>
          </DynamicThemeProvider>
        </Provider>
      </Auth0Provider>
    </CacheBuster>
  );
};

root.render(<AppRedux />);
serviceWorker.register({
  onUpdate: (registration) => {
    // Store the worker so you can trigger SKIP_WAITING later, e.g. via context or a global signal
    console.log("Service Worker update available");
    // You can use a global event emitter, Redux, or a context here if you want to replicate the reload dialog
    window.__waitingWorker = registration.waiting;
    window.dispatchEvent(new Event("swUpdated")); // or use any state management you prefer
  },
});
